// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__nAaAJ","loader":"Loader_loader__fIbNX","loading":"Loader_loading__d3oYc"};